<div class="w-100 bg-w dea-radius dea-shadow dea-padding">
  <ng-content></ng-content>
</div>